var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.property
    ? _c(
        "div",
        [
          _vm.hasRoleToRead
            ? _c("router-link", { attrs: { to: _vm.route } }, [
                _vm._v(_vm._s(_vm.property.label))
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.hasRoleToRead
            ? _c("span", [_vm._v(_vm._s(_vm.property.label))])
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c8ebf40", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c8ebf40","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/entity-link.vue
// module id = null
// module chunks = 